import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    width: '100%',
  },
  step: {
    flexDirection: 'row',
  },
  left: {},
  right: {
    flex: 1,
  },
});

export default styles;
